import React from 'react'
import { I18n } from '@front/volcanion'

import { TableCell } from '@mui/material'
import TextHeader from '@abra/elements/table/headers/Text'

const Header = props => <>
  <TableCell align='center'><TextHeader label={I18n.t('date.label', { count: 1 })} icon={'calendar_today'} /></TableCell>
  <TableCell align='center'><TextHeader label={I18n.t('incident.current', { count: 1 })} /></TableCell>
  <TableCell align='center'><TextHeader label={I18n.t('commercial_formula.label', { count: 1 })} /></TableCell>
  <TableCell align='center'><TextHeader label={I18n.t('driver.label', { count: 1 })} icon={'local_taxi'} /></TableCell>
</>

export default React.memo(Header)
